export const PORTAL_MODAL_NAMES = {
  PUBLISH_PAGE: 'publishPageModal',
  PUBLISH_CONTENT: 'publishContentModal',
  DELETE_TABLE_POPUP: 'deletePopupModal',
  DELETE_BADGE: 'deleteBadgeModal'
} as const;

export const modalConfigs: Record<
  string,
  { title: string; description: string }
> = {
  [PORTAL_MODAL_NAMES.PUBLISH_PAGE]: {
    title: 'Publish Page',
    description:
      'Are you sure want to publish this page? Saving these changes will make the page public.'
  },
  [PORTAL_MODAL_NAMES.PUBLISH_CONTENT]: {
    title: 'Publish Content',
    description: 'This will make the content accessible to everyone'
  },
  [PORTAL_MODAL_NAMES.DELETE_TABLE_POPUP]: {
    title: 'Delete Popup',
    description: 'Are you sure want to delete this popup?'
  },
  [PORTAL_MODAL_NAMES.DELETE_BADGE]: {
    title: 'Delete Badge',
    description: 'Are you sure want to delete this badge?'
  }
};
